import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { request, message as mes } from 'meinian-package/src/utils'
import './index.less'
import { Tag,
  BatchStart, BatchAll, BatchNum, BatchStop, BatchOptions
} from 'component'
import { Empty, Loading, Select } from 'meinian-package/src/baseComponent'

function convert(result) {
  const all = []
  result.forEach((m) => {
    if (!m.firstChar) {
      return
    }
    const item = all.find(n => n.firstChar === m.firstChar)
    if (!item) {
      all.push({ firstChar: m.firstChar, list: [m] })
    } else {
      item.list.push(m)
    }
  })
  return all
}
const TAG_OPTIONS = [
  { label: '仅展示个人标签', value: 1 },
  { label: '仅展示非个人标签', value: 2 },
]
// eslint-disable-next-line no-empty-pattern
export default forwardRef((props, ref) => {
  const [initials, setInitials] = useState([])
  const [res, setRes] = useState([])
  const [tags, setTags] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)
  const [isBatch, setIsBatch] = useState(false)
  const [displayTag, setDisplayTag] = useState(null)
  useEffect(() => {
    const sub = () => init()
    mes.sub('onMNUploadImage', sub)
    init()
    return () => { mes.remove('onMNUploadImage', sub) }
  }, [displayTag])

  const init = () => {
    fetchInitial()
    fetchTags()
  }

  const fetchInitial = async () => {
    try {
      const _res = await request.get('/zhikuan/img-tag/list-tag-first-char')
      setInitials(_res)
    } catch (error) {
      console.error(error)
    }
  }

  const fetchTags = async () => {
    setLoading(true)
    try {
      const _res = await request.post('/zhikuan/img-tag/selector', { tagCreatorFilter: displayTag, rankStatus: 2 })
      setRes(_res)
      setTags(convert(_res))
      setTotal(_res.filter(m => m.firstChar).length)
    } catch (error) {
      console.error(error)
    }
    setLoading(false)
  }

  useImperativeHandle(ref, () => {
    return {
      init
    }
  })

  return <div className="meinian-home-tag">
    <div className="tag-nav">
      {initials.map(i => <a className={`initial ${location.hash === `#${i}` ? 'active' : ''}`} href={`#${i}`}>{i}</a>)}
    </div>
    <div className="title">
      {isBatch ? <>
        <div className="meinian-space" />
        <BatchAll style={{ marginRight: 16 }} keyValues={res.map(m => m.tagId)} />
        <BatchNum style={{ marginRight: 40 }} />
        <BatchOptions.MergeTags onChange={() => { setIsBatch(false); init() }} />
        <BatchOptions.DeleteTags onChange={() => { setIsBatch(false); init() }} />
        <BatchStop onClick={() => setIsBatch(false)} />
      </> : <>
        <div className="name">我的标签</div>
        <span className="total">({total})</span>
        <div className="meinian-space" />
        <Select
          trigger="click"
          placeholder="标签展示"
          data={TAG_OPTIONS}
          value={displayTag}
          displayStyle={{ maxWidth: 'fit-content' }}
          ulStyle={{ minWidth: '144px' }}
          container={document.body}
          onChange={(val, item) => setDisplayTag(item?.value)}
        />
        <BatchStart onClick={() => setIsBatch(true)} placeholder="批量管理" />
      </>}
    </div>
    <Loading spinning={loading}>
      {tags.length ? <div className="tag-content">
        {tags.map(item => <div className="tag-wrap">
          <div id={item.firstChar} style={{ position: 'relative', top: -65, left: -260 }} />
          <div className="tag-title">{item.firstChar}</div>
          <div className="tag-info">
            {item.list.map(tag => <Tag tag={tag} setTags={setTags} init={init} isBatch={isBatch} />)}
          </div>
        </div>)}
      </div>
        : <Empty type="tag" title="暂无相关标签" subTitle={<>为款式添加标签，方便管理与查找。<a className="link" href="/meinian/document?id=41" target="_blank">查看如何添加标签？</a></>} loading={loading} />}
    </Loading>
  </div>
})
